/** Examples are checked against the independently built native AML worker. */
export const amlExamples=[
 {id:'input-output',title:'Enter values and display a result',profile:'calculation',stdin:'2\n3\n',source:`a = input("Enter a:")
b = input("Enter b:")
output("Sum:", a + b)`,expected:['Sum: 5']},
 {id:'arithmetic',title:'Arithmetic and printed output',profile:'calculation',source:`// A calculation file: press Run in AEE.
a = 2
b = 3
output("Addition:", a + b)
output("Subtraction:", a - b)
output("Multiplication:", a * b)
output("Division:", a / b)
output("Power:", a ^ 3)
output("Grouped:", (a + b) * 4)`,expected:['Addition: 5','Subtraction: -1','Multiplication: 6','Power: 8','Grouped: 20']},
 {id:'assignments',title:'Inferred and explicit types',profile:'calculation',source:`samples = 100
double tolerance = 1e-8
float gain = 2.5
long count = 1000
bool enabled = true
string label = "Matrix study"
samples = 120
output(label, samples, tolerance, gain, count, enabled)`},
 {id:'matrices',title:'Your matrix calculation',profile:'calculation',source:`a = 2
b = 3
c = 4
A = [a, b;
     b, a]
B = [a, c;
     b, a]
output("Matrix Addition:", A + B)
output("Matrix Subtraction:", A - B)
output("Matrix Multiplication:", A * B)
output("Scalar Multiplication:", 2 * A)
output("Right Scaling:", A * 2)
output("Matrix Division:", A / 2)`,expected:['[ 13  14 ]','[ 12  16 ]','[ 4  6 ]','[ 6  4 ]']},
 {id:'linear-algebra',title:'Matrix functions and a small linear system',profile:'calculation',source:`A = [4, 1;
     2, 3]
B = [9;
     8]
X = inverse(A) * B
output("X:", X)
output("det(A):", det(A))
output("transpose(A):", transpose(A))
output("eigenvalues:", eigenvalues(A))
output("eigenvectors:", eigenvectors(A))`},
 {id:'vectors',title:'Vectors and scalar functions',profile:'calculation',source:`v = [1, 2, 3]
output("Scaled vector:", 2 * v)
output("Mean:", mean(v))
output("Square roots:", sqrt(v))
output("Absolute:", abs(-3))
output("Natural log:", log(exp(1)))
x = linspace(0, 6.283185307, 101)
y = sin(x)
plot(x, y, "sine_wave")`},
 {id:'gain',title:'A behavior with two inputs and one output',profile:'behavior',source:`block TwoInputGain
{
    input signal: Real
    input bias: Real
    output result: Real
    parameter gain: Real = 2.0
    compute
    {
        result = gain * signal + bias
    }
}`},
 {id:'state',title:'Persistent state and physical units',profile:'behavior',source:`block Accumulator
{
    input rate: RealPerTime
    output result: Real
    state total: Real = 0
    initialize
    {
        total = 0
        result = 0
    }
    compute
    {
        result = total
    }
    update(dt: Time)
    {
        total = total + rate * dt
    }
}`},
 {id:'loops',title:'Branches, bounded loops, require and return',profile:'behavior',source:`block SumAndClamp
{
    input enabled: Boolean
    input limit: Real
    output result: Real
    compute
    {
        if !enabled
        {
            result = 0
            return
        }
        require limit >= 0
        let total = 0
        for i in 0 .. 4
        {
            total = total + i
        }
        result = math.clamp(total, 0, limit)
    }
}`},
 {id:'units',title:'Dimension checking in behavior code',profile:'behavior',source:`block PressureAlarm
{
    input pressure: Pressure
    output alarm: Boolean
    parameter limit: Pressure = 2 bar
    compute
    {
        alarm = pressure > limit
    }
}`},
 {id:'composition',title:'System composition source',profile:'system-model',source:`model SignalChain
{
    instance command = Constant()
    instance gain = Gain()
    instance display = Display()
    connect command.out -> gain.u
    connect gain.y -> display.in
}`},
] as const;
